import { Component, computed, inject, input, OnDestroy, output, signal } from '@angular/core';

import { DatePipe } from '@angular/common';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { dsEnums, webDtos } from '@vectronic/openApi-admin';
import { ScheduleTimpespanPreview, utcMoment } from '@vectronic/util';
import { Subscription } from 'rxjs';
import { AbstractScheduleService } from '../../services/abstract-schedule.service';
import { ScheduleCalendarCalculationService } from '../../services/schedule-calendar-calculation.service';
import { ScheduleServices } from '../../services/schedule.service';
import { CalendarTimespanComponent } from '../calendar-timespan/calendar-timespan.component';

@Component({
  selector: 'rc-calendar-day-view-beacon',
  templateUrl: './calendar-day-view-beacon.component.html',
  styleUrls: ['./calendar-day-view-beacon.component.scss'],
  imports: [MatIconButton, MatTooltip, MatIcon, CalendarTimespanComponent, DatePipe],
})
export class CalendarDayViewBeaconComponent implements OnDestroy {
  private scheduleServices = inject(ScheduleServices);
  private calendarCalculationService = inject(ScheduleCalendarCalculationService);

  selectedDate = input<Date | null>();
  schedulePreview = signal<ScheduleTimpespanPreview[]>(undefined);
  rulesArray = signal<webDtos.ScheduleRule[]>(undefined);
  scheduleType = input<dsEnums.ScheduleType>();

  dayChange = output<Date>();
  back = output();

  subscription: Subscription;

  scheduleService = computed<AbstractScheduleService>(() => {
    if (!this.scheduleType()) return undefined;
    return this.scheduleServices[this.scheduleType()];
  });

  constructor() {
    toObservable(this.scheduleService)
      .pipe(takeUntilDestroyed())
      .subscribe((service) => {
        this.subscription?.unsubscribe();
        if (service) {
          this.subscription = service.rules$.subscribe((rules) => {
            this.rulesArray.set(Object.values(rules));
            this.updateSchedulesInDay();
          });
        }
      });

    toObservable(this.selectedDate)
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.updateSchedulesInDay();
      });
  }

  updateSchedulesInDay() {
    const schedules: ScheduleTimpespanPreview[] = [];
    const service = this.scheduleService();
    if (service) {
      this.rulesArray()?.forEach((rule) =>
        schedules.push(
          ...this.calendarCalculationService.timespanInDay(
            rule,
            utcMoment(this.selectedDate(), true),
            service.config,
          ),
        ),
      );
    }
    this.schedulePreview.set(Array.from(schedules.values()));
  }

  onClickBack() {
    this.back.emit();
  }

  onClickPrevious() {
    this.dayChange.emit(utcMoment(this.selectedDate(), true).add('day', -1).toDate());
  }

  onClickNext() {
    this.dayChange.emit(utcMoment(this.selectedDate(), true).add('day', 1).toDate());
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
